// 썸네일 정보 확인 http://photo.navercorp.com/#delivery/view/thumbnail
export enum PhotoInfraService {
  COMMON = 'common',
  CONTACT = 'contact',
  LDB = 'ldb',

  MYMONEY = 'mymoney',
  MYPLACE = 'myplace',
  PUP_REVIEW = 'pup-review',
  VIDEO_PLATFORM = 'video',
}

// 필요하면 타입 검색해서 추가하기 http://photo.navercorp.com/#delivery/view/thumbnail
export type PhotoInfraThumbnail = {
  [PhotoInfraService.COMMON]: 'f114_114' | 'f174_174' | 'f222_222' | 'f48_48' | 'h320_sharpen' | 'w560_sharpen'
  [PhotoInfraService.CONTACT]: 'f102_102' | 'f60_60' | 'f210_210'
  [PhotoInfraService.LDB]: 'f80_80_60_sharpen_autoRotate' | 'f110_110' | 'f434_330'

  [PhotoInfraService.MYMONEY]: 'a150_235'
  [PhotoInfraService.MYPLACE]:
    | 'f120'
    | 'f220_220_70_sharpen'
    | 'f220_220_gif'
    | 'f352_440'
    | 'f440_440'
    | 'f442_442_70_sharpen'
    | 'f50_blur'
    | 'f660_440'
    | 'f80_80'
    | 'f828_828_70_sharpen'
    | 'f912_1140'
    | 'f912_608'
    | 'f912_912'
    | 'm385_385_70_sharpen'
  [PhotoInfraService.PUP_REVIEW]:
    | 'f120'
    | 'f220_220_70_sharpen'
    | 'f352_440'
    | 'f440_440'
    | 'f442_442_70_sharpen'
    | 'f50_blur'
    | 'f510_510_70_sharpen'
    | 'f660_440'
    | 'f80_80'
    | 'f828_828_70_sharpen'
    | 'f912_1140'
    | 'f912_608'
    | 'f912_912'
    | 'm385_385_70_sharpen'
    | 'w828_60_sharpen'
  [PhotoInfraService.VIDEO_PLATFORM]:
    | 'f120' // 미디어 뷰어 인덱스 썸네일
    | 'f220_220_70_sharpen' // 방문탭/방문엔드 리뷰 썸네일
    | 'f352_440' // 리작완 동영상 세로형 썸네일
    | 'f440_440' // 리작완 동영상 정방형 썸네일
    | 'f442_442_70_sharpen' // 리뷰 작성 / 수정 썸네일
    | 'f50_blur'
    | 'f510_510_70_sharpen' // 리뷰탭 리뷰 썸네일
    | 'f660_440' // 리작완 동영상 가로형 썸네일
    | 'f912_1140' // 엔드 동영상 세로형 썸네일
    | 'f912_608' // 엔드 동영상 가로형 썸네일
    | 'f912_912' // 엔드 동영상 정방형 썸네일
    | 'w800'
    | 'w828_60_sharpen' // 리뷰엔드 썸네일, 테마리스트 리뷰 썸네일
}

export const DEFAULT_PHOTOINFRA_THUMBNAILS: PhotoInfraThumbnail = {
  [PhotoInfraService.COMMON]: 'w560_sharpen',
  [PhotoInfraService.CONTACT]: 'f102_102',
  [PhotoInfraService.LDB]: 'f110_110',
  [PhotoInfraService.MYMONEY]: 'a150_235',
  [PhotoInfraService.MYPLACE]: 'f442_442_70_sharpen',
  [PhotoInfraService.PUP_REVIEW]: 'f442_442_70_sharpen',
  [PhotoInfraService.VIDEO_PLATFORM]: 'f442_442_70_sharpen',
}

export type PlaceThumbnailTypes = Pick<PhotoInfraThumbnail, PhotoInfraService.LDB | PhotoInfraService.COMMON>

/**
 * myplace 서비스는 리뷰에서 제거될 예정(pup_review로 이관)
 * 나중에 제거되면 타입에서 삭제
 * + 예전 에약리뷰도 남아있는 듯...
 * ex. https://m.place.naver.com/my/theme/5f9cfb0936654f005a8e6980
 */
export type ReviewThumbnailTypes = Pick<
  PhotoInfraThumbnail,
  PhotoInfraService.PUP_REVIEW | PhotoInfraService.MYPLACE | PhotoInfraService.VIDEO_PLATFORM
>

/**
 * 예전에 가입후 프로필 변경하지 않은 유저는 회원 프로필을 사용하기 때문에 contact 추가
 */
export type ProfileThumbnailTypes = Pick<PhotoInfraThumbnail, PhotoInfraService.MYPLACE | PhotoInfraService.CONTACT>

export type PartialPhotoInfraThumbnail = Partial<PhotoInfraThumbnail>

export type ReviewCommonThumbnailType = PhotoInfraThumbnail['myplace'] &
  PhotoInfraThumbnail['pup-review'] &
  PhotoInfraThumbnail['video']
